import { getApiClient } from './apiClient'

const apiClient = getApiClient(process.env.REACT_APP_UPDATE_CUSTOMER_KIT_MATERIAL_URL)

export const updateCustomerKitMaterial = async (customerId, materialNumber, workingDepth) => {
  // const deckRevisions = await DataStore.query(DeckRevisions)
  // for (const deckRevision of deckRevisions) {
  //   if (
  //     deckRevision.CustomerId !== customerId ||
  //     !deckRevision.Kits.some((kit) => kit.MaterialNumber === materialNumber)
  //   ) {
  //     continue
  //   }
  //   const kits = structuredClone(deckRevision.Kits)
  //   const kitsToUpdate = []

  //   for (const kit of kits) {
  //     if (kit.MaterialNumber === materialNumber) {
  //       console.log('kitsUopdate', {
  //         kitsToUpdate
  //       })
  //       kit.WorkingDepth = workingDepth
  //     }
  //     kitsToUpdate.push(kit)
  //   }
  //   await DataStore.save(
  //     DeckRevisions.copyOf(deckRevision, (updated) => {
  //       updated.Kits = kits
  //     })
  //   )
  // }

  return apiClient.patch('/kits', {
    customerId,
    materialNumber,
    workingDepth
  })
}

export const getUpdateStatus = (id) => {
  return apiClient.get(`/kits/${id}/`)
}
